export const testimonials = [
  {
    name: "Dr. Ananya Rao",
    designation: "Director",
    industry: "Rao Multispeciality Clinic",
    quote:
      "Our front desk used to run on registers and personal WhatsApp. Social Wavez connected our website, patient CRM and appointment reminders into one system — no-shows dropped, and my team finally works from a single screen.",
    result: "42% fewer no-shows in 90 days",
  },
  {
    name: "Rohit Malhotra",
    designation: "Partner",
    industry: "Malhotra & Associates, CA Firm",
    quote:
      "They understood our compliance workflow before writing a single line of code. The client portal they built ended the document-chasing over email, and client status reports now build themselves every Monday morning.",
    result: "6+ hours saved weekly per manager",
  },
  {
    name: "Sarah Thomas",
    designation: "Founder",
    industry: "Launchpad Consulting",
    quote:
      "Website, booking, CRM, email automation — everything talks to everything. I stopped losing discovery-call leads within the first month. They think like business partners, not technology vendors.",
    result: "Zero missed follow-ups since launch",
  },
  {
    name: "Vikram Singhania",
    designation: "Head of Operations",
    industry: "Singhania Realty",
    quote:
      "Every enquiry from our website and the portals lands in one pipeline, agents get nudged automatically, and I watch the whole funnel live. The dashboard alone changed our Monday meetings.",
    result: "Full live pipeline visibility",
  },
];
